import { render, staticRenderFns } from "./Saturation.vue?vue&type=template&id=0d72c8ca"
import script from "./Saturation.vue?vue&type=script&lang=js"
export * from "./Saturation.vue?vue&type=script&lang=js"
import style0 from "./Saturation.vue?vue&type=style&index=0&id=0d72c8ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports